import { EmailAddress } from '@constants';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import feedbackSuccess from '@assets/bp_feedback_success.svg';

import classes from './Feedback.module.css';

const FEEDBACK_TEXT = {
  title: 'Congrats!',
  desc: 'Your application has been submitted. As soon as we’ve matched your products with warranty contracts you will be able to start selling! We‘ll send you an email when it’s ready.',
  paragraph: ' Should you have any questions, please contact us at ',
};

export default function Feedback() {
  return (
    <div className={classes.feedback}>
      <div className={classes.content}>
        <img src={feedbackSuccess} alt="" className={classes.img} />
        <div className={classes.title}>{FEEDBACK_TEXT.title}</div>
        <div className={classes.desc}>
          <div>{FEEDBACK_TEXT.desc}</div>
          <br />
          {FEEDBACK_TEXT.paragraph}
          <a href={`mailto: ${EmailAddress.Seel}`} style={{ color: '#645AFF' }}>
            {EmailAddress.Seel}
          </a>
          .
        </div>
        <Link to="/">
          <Button>Back to home</Button>
        </Link>
      </div>
    </div>
  );
}
